import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledComponent, StyledDivComponent } from '../types';

interface CardRectBodyProps {
  smallGap?: boolean;
}

type CardRectBodyPropsThemed = ThemeProps<Theme> & CardRectBodyProps;

export const CardRectBody: StyledDivComponent<CardRectBodyProps> = styled.div`
  position: relative;
  margin: 0 0
    ${(props: CardRectBodyPropsThemed) => (props.smallGap ? '4px' : '30px')};
  padding: 20px;
  background: ${(props: CardRectBodyPropsThemed) =>
    props.theme.colors.grayLight};

  ${media.medium`
    padding: 25px;
  `}
`;

interface CardRectHeadProps {
  left?: boolean;
}

type CardRectHeadPropsThemed = ThemeProps<Theme> & CardRectHeadProps;

export const CardRectHead: StyledComponent<CardRectHeadProps> = styled.header`
  ${font(2.5, 3.2, '500')};
  margin: 0 0 4px;
  padding: 25px;
  text-align: ${(props: CardRectHeadPropsThemed) =>
    props.left ? 'left' : 'center'};
  background: ${(props: CardRectHeadPropsThemed) =>
    props.theme.colors.secondary};
  color: ${(props: CardRectHeadPropsThemed) => props.theme.colors.white};

  small {
    ${font(1.6, 2, '500')};
    display: block;
    margin: 4px 0 0;
    color: ${(props: CardRectHeadPropsThemed) => props.theme.colors.white};
    opacity: 0.5;
  }
`;
